export const capitalizeFirstLetter: (text: string) => string = (text = '') =>
  text
    .toLowerCase()
    .replace(/^\w/, (c) => c && c.toUpperCase())
    .replace('_', ' ');
